<template>
    <vx-card :title='$t("Vehicles")'>
        <vs-table ref="table" pagination :max-items="50" search :data="vehicles">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ vehicles.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : vehicles.length }} of {{ vehicles.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="type">{{$t("Type")}}</vs-th>
                <vs-th sort-key="registration">{{$t("Registration")}}</vs-th>
                <vs-th sort-key="last_kilometers">{{$t("LastKilometers")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].type">
                        {{ data[index].type }}
                    </vs-td>

                    <vs-td :data="data[index].registration">
                        {{ data[index].registration }}
                    </vs-td>

                    <vs-td :data="data[index].last_kilometers">
                        {{ data[index].last_kilometers }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>
    </vx-card>
</template>
<script>

    export default {
        props: {
            userId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                vehicles: [],

                itemsPerPage: 20,
                isMounted: false,
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            updateVehicles() {
                const thisIns = this;
                this.$http.get('/api/v1/user/' + this.userId + '/vehicles/')
                    .then(function (response) {
                        thisIns.vehicles = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
        },
        created() {
            this.updateVehicles()
        },
        mounted() {
            this.isMounted = true;
        },
    }
</script>
